import axios from 'axios';
import { buildBlogApiUrl } from '../../config/apiConfig';

export type BlogArticleLink = { slug: string; title: string };

/** Parité seo-bot : pagination API (max 50 / page). */
export async function fetchAllBlogArticles(locale: string): Promise<BlogArticleLink[]> {
  const articles: BlogArticleLink[] = [];
  for (let page = 1; page <= 4; page += 1) {
    const response = await axios.get<{ articles?: { slug?: string; title?: string }[] }>(
      buildBlogApiUrl('/blog/articles'),
      {
        params: {
          page,
          limit: 50,
          site: 'pro',
          lang: locale,
        },
      }
    );
    const batch = response.data.articles ?? [];
    for (const article of batch) {
      if (article?.slug && article?.title) {
        articles.push({ slug: article.slug, title: article.title });
      }
    }
    if (batch.length < 50) break;
  }
  return articles;
}
